import { EstablishmentMovementsTotalizerData } from "@/features/establishments/types/establishmentMovementsTotalizer.type";
export const establishmentResumeItems = (data: EstablishmentMovementsTotalizerData) => {
    return [
      {
        label: "Faturamento",
        value: data.consumed_total,
      },
      {
        label: "Descontos",
        value: data.discount_total || data.discounts_total,
      },
      {
        label: "Total em tarifas",
        value: data.fees_total,
      },
      {
        label: "Total de IR",
        value: data.income_tax_total,
      },
      {
        label: "Total Transacionado",
        value: data.transacted_total,
        textClassName: "text-yellow-400",
      },
      {
        label: "Pagáveis",
        value: data.payable,
        textClassName: "text-yellow-400",
      },
    ];
  };
